import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

const promoCodeService = {
  // Fetch a single promo code by id
  get: async (id, accessToken) => {
    try {
      const response = await fetch(`${baseUrl}promo-codes/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return await response.json();
    } catch (error) {
      console.error("Error fetching promo code:", error);
      throw error;
    }
  },

  // Create a new promo code
  create: async (data, accessToken) => {
    try {
      const response = await fetch(`${baseUrl}promo-codes/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
                    "Accept": "application/json", // ✅ ADD THIS - CRITICAL!
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch (error) {
      console.error("Error creating promo code:", error);
      throw error;
    }
  },

  // Update an existing promo code by id
  update: async (id, data, accessToken) => {
    try {
      const response = await fetch(`${baseUrl}promo-codes/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch (error) {
      console.error("Error updating promo code:", error);
      throw error;
    }
  },

  // Delete a promo code by id
  delete: async (id, accessToken) => {
    try {
      const response = await fetch(`${baseUrl}promo-codes/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return await response.json();
    } catch (error) {
      console.error("Error deleting promo code:", error);
      throw error;
    }
  },

  // Fetch all promo codes with optional query parameters (e.g., 'all=true')
  getAll: async (accessToken, { all = true, page = 1, perPage = 10 }={}) => {
    try {
      const queryParams = new URLSearchParams();

      if (all) {
        queryParams.append("all", "true");
      } else {
            queryParams.append("page", page.toString());
            queryParams.append("perPage", perPage.toString());
      }

      const response = await fetch(
        `${baseUrl}users/promoCodes?${queryParams.toString()}`,
        {
          headers: {
            // "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      return await response.json();
    } catch (error) {
      console.error("Error fetching all promo codes:", error);
      throw error;
    }
  },
   getSeekerPromoCodes: async (
    accessToken,
    { all = true, page = 1, perPage = 10 } = {}
  ) => {
    try {
      const queryParams = new URLSearchParams();

      if (all) {
        queryParams.append("all", "true");
      } else {
        queryParams.append("page", page.toString());
        queryParams.append("perPage", perPage.toString());
      }

      const response = await fetch(
        `${baseUrl}users/seekerPromoCodes?${queryParams.toString()}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      return await response.json();
    } catch (error) {
      console.error("Error fetching seeker promo codes:", error);
      throw error;
    }
  },
};

export default promoCodeService;
